import { ModulosFornecedorModel } from "../models/modulosFornecedorModel"

export enum ModulosFornecedorActionsTypes {
    CARREGAR = "CARREGAR",
}

export type ModulosFornecedorActionModel = {
    type: ModulosFornecedorActionsTypes.CARREGAR
    payload: ModulosFornecedorModel
}
